import React from "react"
import { Helmet } from "react-helmet"
import favicon from "../images/favicon.png"
import ProximaNovaLight from "../fonts/ProximaNova-Light.woff2"
import ProximaNovaBold from "../fonts/ProximaNova-Bold.woff2"
import ProximaNovaRegular from "../fonts/ProximaNova-Regular.woff2"
import ProximaNovaSemiBold from "../fonts/ProximaNova-Semibold.woff2"
import ProximaNovaExtraBold from "../fonts/ProximaNova-Extrabld.woff2"
import ProximaNovaExtraBoldItalic from "../fonts/ProximaNova-ExtrabldIt.woff2"
import ProximaNovaThin from "../fonts/ProximaNova-Thin.woff2"
import ProximaNovaThinItalic from "../fonts/ProximaNova-ThinIt.woff2"
import ProximaNovaBlack from "../fonts/ProximaNova-Black.woff2"
import BitterBold from "../fonts/Bitter-Bold.woff2"
import BitterRegular from "../fonts/Bitter-Regular.woff2"
import BitterBoldItalic from "../fonts/Bitter-BoldItalic.woff2"
import BitterBlack from "../fonts/Bitter-Black.woff2"

const Seo = props => {
  return (
    <>
      {props.page !== undefined && props.page === "blogIndexPage" ? (
        <Helmet title="blog">
          <link
            rel="preload"
            href={ProximaNovaLight}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaBold}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaRegular}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaSemiBold}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaExtraBold}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaExtraBoldItalic}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaThinItalic}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaThin}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaBlack}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={BitterBold}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={BitterRegular}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={BitterBoldItalic}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={BitterBlack}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link rel="icon" href={favicon} />
          <html lang="en" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0"
          />
          <meta property="og:title" content="Blog" />
          <script
            async
            type="text/javascript"
            src={process.env.GATSBY_BIRDEYE_CHATBOT_URL}
          ></script>
          <div id={process.env.GATSBY_BIRDEYE_WIDGET_ID}></div>
        </Helmet>
      ) : (
        <Helmet title={props.data.title}>
          <link
            rel="preload"
            href={ProximaNovaLight}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaBold}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaRegular}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaSemiBold}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaExtraBold}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaExtraBoldItalic}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaThinItalic}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaThin}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={ProximaNovaBlack}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={BitterBold}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={BitterRegular}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={BitterBoldItalic}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href={BitterBlack}
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link rel="icon" href={favicon} />
          <html lang="en" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0"
          />
          {props.data.title && (
            <meta property="og:title" content={props.data.title} />
          )}
          {props.data.metaDescription && (
            <meta name="description" content={props.data.metaDescription} />
          )}
          {props.data.ogImage !== null && (
            <meta name="image" content={props.data.ogImage} />
          )}
          {props.data.ogUrl && (
            <meta property="og:url" content={props.data.ogUrl} />
          )}
          {props.data.ogSiteName && (
            <meta property="og:site_name" content={props.data.ogSiteName} />
          )}

          {props.page !== undefined && props.page === "blogPost" ? (
            <meta property="og:type" content="article" />
          ) : null}
          {props.data.ogTitle && (
            <meta property="og:title" content={props.data.ogTitle} />
          )}
          {props.data.ogDescription && (
            <meta
              property="og:description"
              content={props.data.ogDescription}
            />
          )}
          {props.data.ogImage !== null && (
            <meta property="og:image" content={props.data.ogImage} />
          )}

          {props.data.canonicalUrl && (
            <link rel="canonical" href={props.data.canonicalUrl} />
          )}

          <meta name="twitter:card" content="summary_large_image" />

          {/* Twitter */}
          {props.data.twitterTitle && (
            <meta name="twitter:title" content={props.data.twitterTitle} />
          )}
          {props.data.twitterDescription && (
            <meta
              name="twitter:description"
              content={props.data.twitterDescription}
            />
          )}
          {props.data.twitterImage !== null && (
            <meta name="twitter:image" content={props.data.twitterImage} />
          )}
        </Helmet>
      )}
    </>
  )
}
export { Seo }
